class CustomerServiceModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-customer-service-modal-external-el="trigger"]',
    )

    if (!trigger) return

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.toggle('util-SiteOverflowed', true)
  }
}

if (!customElements.get('customer-service-modal')) {
  customElements.define('customer-service-modal', CustomerServiceModal)
}
